import React from 'react';
import { Alert, AlertTitle, Typography } from '@mui/material';
import { isBefore } from 'date-fns';

const CommissionInfo = ({ tripMatch, tripPrice, tripCommission }: {
  tripMatch: any, tripPrice: { amount: number, currencyCode: string | undefined },
  tripCommission: { amount: number, currencyCode: string | undefined } }) => {
  const tripMatchCreatedAt = new Date(tripMatch.createdAt);
  const isBeforeOct1 = isBefore(tripMatchCreatedAt, new Date('2025-10-01'));
  const commissionPercentage = tripPrice.amount
    ? ((tripCommission.amount / tripPrice.amount) * 100).toFixed(1)
    : '0.0';

  if (isBeforeOct1 && Number(commissionPercentage) < 8) {
    return (
      <Alert severity="error">
        <AlertTitle>Commission Discrepancy</AlertTitle>
        <Typography>
          Current commission reported is
          {' '}
          <Typography component="span">
            {commissionPercentage}
            %.
          </Typography>
          {' '}
          This trip was matched before Oct 1, 2025; the commission rate is 8% of the total trip price.
          The only exception is separately priced airfare.
        </Typography>
      </Alert>
    );
  }

  if (!isBeforeOct1 && Number(commissionPercentage) < 10.5) {
    return (
      <Alert severity="error">
        <AlertTitle>Commission Discrepancy</AlertTitle>
        <Typography>
          Current commission reported is
          {' '}
          <Typography component="span">
            {commissionPercentage}
            %.
          </Typography>
          {' '}
          This trip was matched on or after Oct 1, 2025; the commission rate is 10.5% of the total trip price.
          The only exception is separately priced airfare.
        </Typography>
      </Alert>
    );
  }

  return null;
};

export default CommissionInfo;
